// blogData.js

import blog1 from "../../assets/images/blog_1.jpg";
import blog2 from "../../assets/images/blog_2.jpg";
import blog3 from "../../assets/images/blog_3.jpg";
import blog4 from "../../assets/images/blog_4.jpg";
import blog5 from "../../assets/images/blog5.png";
import figure5 from "../../assets/images/figure5.png";
import blog8 from "../../assets/images/blog8-1.png";
import blog9 from "../../assets/images/blog9-2.png";
import blog10 from "../../assets/images/blog10-9.png";
import blog11 from "../../assets/images/blog11-10.png";
import blog12 from "../../assets/images/blogImg12-1.png";
import blog13 from "../../assets/images/blog13-1.png";
import blog14 from "../../assets/images/blog14-28.png";
import blog15 from "../../assets/images/Blog15-Images/image1 Blog SPX .png";
import blog16 from "../../assets/images/blog16-16.png";
import blog17 from "../../assets/images/blog17-2.png";
import blog18 from "../../assets/images/blog18-10.png";
import blog19 from "../../assets/images/blog19/image2 US debt burden projection.png";
import blog20 from "../../assets/images/blog20/blog20-1.png";
import blog21 from "../../assets/images/blog21/blog21-1.png";
import blog22 from "../../assets/images/blog22/image16 bullish naratives.png";
import blog23 from "../../assets/images/Blog23/image1 trump at G7 no co-ordination.png";
import blog24 from "../../assets/images/blog24/blog24-36.png";
import blog25 from "../../assets/images/blog25/blog25-1.png";
import blog26 from "../../assets/images/Blog26/image13.png";
import blog27 from "../../assets/images/blog27/blog27-1.png";
import blog28 from "../../assets/images/Blog28/image2.png";
import blog29 from "../../assets/images/blog29/image7.PNG";
import blog30 from "../../assets/images/Blog30/image21 NAs100 Aug top still to come_.png";
import blog31 from "../../assets/images/Blog31/image1 nas100 new ATH close.png";
import blog32 from "../../assets/images/Blog32/image5 dramatic US CPI chart (1).jpeg";
import blog33 from "../../assets/images/Blog33/image1.png";
import blog34 from "../../assets/images/Blog34/image1 fed for Sep.png";
import blog35 from "../../assets/images/Blog35/image3 hawkish dotplot ignored.png";
import blog36 from "../../assets/images/Blog36/image3 nas100 gamma flip.png";
import blog37 from "../../assets/images/Blog37/image10 non-profit squeeze.png";

export const blogData = [
  {
    id: 1,
    title: "How to Find Your Trading Style: The Best Trading Strategy for You",
    colorText: "Strategy for You",
    content: `
        <p>Embarking on a trading journey can be both exciting and daunting. With a myriad of trading styles and strategies available, finding the one that suits you best is crucial for long-term success. Whether you’re drawn to the fast-paced world of day trading or the strategic patience of position trading, understanding your personal strengths, risk tolerance, and lifestyle is key to selecting the right approach. Here’s a guide to help you identify which type of trader you are and the trading strategy that aligns with your goals.</p>

<h2>1. <span>Understand</span> the Different Trading Styles</h2>
<p class="blog1_p">Before you can choose a strategy, it’s important to understand the main types of trading styles:</p>
<ul>
<li><span>Scalping:</span> This involves making numerous trades throughout the day to capture small price movements. Scalpers need to be quick, decisive, and able to handle high-pressure situations.</li>
<li><span>Day Trading:</span> Day traders buy and sell securities within the same trading day. This style requires focus and the ability to analyze market trends quickly.</li>
<li><span>Swing Trading:</span> Swing traders hold positions for several days to weeks, aiming to profit from short- to medium-term price movements. This style suits those who can dedicate time to market analysis but prefer not to trade daily.</li>
<li><span>Position Trading:</span> This long-term approach involves holding positions for months or even years. Position traders rely on fundamental analysis and are less concerned with short-term market fluctuations.</li>
</ul>

<h2>2. <span>Assess</span> Your Personality and Lifestyle</h2>
<p class="blog1_p">Your personality and lifestyle play a significant role in determining the best trading style for you:</p>
<ul>
<li><span>Risk Tolerance:</span> Are you comfortable with high-risk, high-reward scenarios, or do you prefer a more conservative approach? Scalping and day trading often involve higher risk, while swing and position trading may offer more stability.</li>
<li><span>Time Commitment:</span> How much time can you dedicate to trading? Scalping and day trading require constant attention, whereas swing and position trading allow for more flexibility.</li>
<li><span>Decision-Making Style:</span> Are you quick to make decisions, or do you prefer to analyze all options before acting? Fast decision-makers may thrive in scalping or day trading, while analytical thinkers might excel in swing or position trading.</li>
</ul>

<h2>3. <span>Evaluate</span> Your Financial Goals</h2>
<p class="blog1_p">Consider what you hope to achieve through trading:</p>
<ul>
<li><span>Income Generation:</span> If your goal is to generate regular income, day trading or scalping might be suitable due to their frequent trading opportunities.</li>
<li><span>Wealth Accumulation:</span> For those focused on long-term wealth accumulation, swing or position trading may be more appropriate, as they allow for compounding gains over time.</li>
</ul>

<h2>4. <span>Experiment</span> and Reflect</h2>
<p class="blog1_p"The best way to find your ideal trading style is through experimentation:</p>
<ul>
<li><span>Demo Trading:</span> Use a demo account to try different trading styles without risking real money. This will help you understand which approach feels most comfortable and aligns with your strengths.</li>
<li><span>Keep a Trading Journal:</span> Document your trades, strategies, and outcomes. Reflecting on your experiences will provide insights into what works best for you.</li>
</ul>

<h2>5. <span>Seek</span> Education and Mentorship</h2>
<p class="blog1_p">Learning from experienced traders can accelerate your journey:</p>
<ul>
<li><span>Courses and Books:</span> Invest in educational resources to deepen your understanding of various trading strategies.</li>
<li><span>Mentorship:</span> Consider finding a mentor who can provide guidance and feedback as you explore different trading styles.</li>
</ul>

<h2>Conclusion</h2>
<p>Identifying the trading style and strategy that suits you best is a personal journey that requires self-reflection, experimentation, and education. By understanding your personality, lifestyle, and financial goals, you can align your trading approach with your strengths and preferences. Remember, the key to successful trading is not just finding the right strategy but also continuously learning and adapting to the ever-changing market landscape.</p>

    `,
    styleClass: "style-1",
    image: blog1,
  },
  {
    id: 2,
    title: "How to Spot Trend Reversals in ",
    colorText: "Trading",
    content: `
          <p>Identifying trend reversals in financial markets is a crucial skill for traders and investors. Recognizing when a trend is losing momentum can present opportunities for profitable trades or help avoid potential losses. Here are some common methods and indicators, supported by statistics, to help you spot potential trend reversals.</p>
    
          <h1>Price Patterns</h1>
    
          <h4>Head and Shoulders</h4>
          <p>The head and shoulders pattern is a classic reversal signal. It consists of three peaks: a higher high (the head) flanked by two lower highs (the shoulders). According to Thomas Bulkowski’s “Encyclopedia of Chart Patterns,” the head and shoulders pattern has a success rate of approximately 83% in predicting trend reversals when confirmed by a break of the neckline.</p>
    
          <h4>Double Top and Double Bottom</h4>
          <p>These patterns occur when the price tests a resistance level twice (double top) or a support level twice (double bottom) without breaking through. Bulkowski’s research indicates that double tops and bottoms have a success rate of about 65% in signaling reversals.</p>
    
          <h4>Triple Top and Triple Bottom</h4>
          <p>Similar to double tops and bottoms, triple tops and bottoms involve three tests at a particular level, suggesting even stronger reversal signals.</p>
    
          <h1>Moving Averages</h1>
          <p>Moving averages are useful for spotting changes in trend direction. A simple strategy is to observe the crossover of shorter-term moving averages (e.g., 50-day) with longer-term ones (e.g., 200-day). Historical data from various market studies shows that the “Golden Cross” (bullish crossover) and “Death Cross” (bearish crossover) can be effective indicators, with success rates varying based on market conditions but often exceeding 60%.</p>
    
          <h1>Relative Strength Index (RSI)</h1>
          <p>The RSI is a momentum oscillator that measures the speed and change of price movements. When RSI reaches overbought (above 70) or oversold (below 30) levels and then reverses, it can indicate a potential trend reversal.</p>
    
          <h1>Divergence</h1>
          <p>Divergence occurs when price movement and an indicator (like RSI or MACD) move in opposite directions. Bullish divergence happens when the price makes lower lows, but the indicator makes higher lows. Bearish divergence is the opposite.</p>
    
          <h1>Candlestick Patterns</h1>
          <p>Certain candlestick patterns, such as engulfing patterns, doji, and hammers, can signal reversals, especially when they appear near support or resistance levels. Research by Steve Nison, a pioneer in candlestick charting, indicates that these patterns can have success rates ranging from 50% to 70%, depending on the market context and confirmation by other signals.</p>
    
          <h1>Volume Analysis</h1>
          <p>An increase in trading volume during a price reversal can confirm the strength of the new trend. A substantial volume increase during a reversal may indicate a valid trend change, with studies showing that volume spikes can enhance the reliability of reversal signals by up to 20%.</p>
    
          <h1>Trendline Breaks</h1>
          <p>Drawing trendlines connecting the lows or highs in an existing trend can help identify reversals. A break of these trendlines can be a sign of a trend reversal.</p>
        `,
    styleClass: "style-2",
    image: blog2,
  },
  {
    id: 3,
    title: "20+ Best Day Trading Podcasts to Get ",
    colorText: "Inspired in 2024",
    content: `
        <p class="blog3_p">In the fast-paced world of day trading, staying informed and inspired is crucial for success. Podcasts offer a convenient way to gain insights from experienced traders, learn new strategies, and keep up with market trends. Whether you’re a seasoned trader or just starting out, these podcasts can provide valuable knowledge and motivation. Here’s a list of some of the best day trading podcasts to follow in 2024:</p>

<h3 class="bold-heading">1. Chat With Traders</h3>
<p>Hosted by Aaron Fifield, this podcast features interviews with successful traders from around the globe. It covers a wide range of trading styles and strategies, making it a valuable resource for day traders looking to expand their knowledge.</p>

<h3 class="bold-heading">2. The Trading Coach Podcast</h3>
<p>Hosted by Akil Stokes, this podcast offers insights into trading psychology, risk management, and technical analysis. Akil’s experience as a trading coach provides listeners with practical advice to improve their trading performance.</p>

<h3 class="bold-heading">3. Top Traders Unplugged</h3>
<p>Niels Kaastrup-Larsen hosts this podcast, which delves into the world of systematic trading. While it covers various trading styles, the insights into market trends and strategies are beneficial for day traders seeking a broader perspective.</p>

<h3 class="bold-heading">4. The Investors Podcast</h3>
<p>This podcast, hosted by Preston Pysh and Stig Brodersen, explores investment strategies and market analysis. While it covers long-term investing, the discussions on market trends and economic factors are valuable for day traders.</p>

<h3 class="bold-heading">5. The AlphaMind Podcast</h3>
<p>Focusing on trading psychology and mindset, hosts Steven Goldstein and Mark Randall provide insights into the mental aspects of trading. This podcast is particularly useful for traders looking to enhance their decision-making skills.</p>

<h3 class="bold-heading">6. The Trading Nut Podcast</h3>
<p>Hosted by Cam Hawkins, this podcast features interviews with traders from various backgrounds. It covers trading strategies, tools, and techniques, offering practical advice for day traders.</p>

<h3 class="bold-heading">7. The Market Huddle</h3>
<p>Patrick Ceresna and Kevin Muir host this podcast, which provides a deep dive into market trends and trading strategies. The discussions are insightful for day traders looking to stay informed about market developments.</p>

<h3 class="bold-heading">8. The SteadyTrade Podcast</h3>
<p>This podcast, hosted by Tim Bohen and Stephen Johnson, focuses on penny stock trading. It offers insights into trading strategies, market analysis, and the challenges of day trading.</p>

<h3 class="bold-heading">9. The Day Trading Show</h3>
<p>Aimed specifically at day traders, this podcast covers trading strategies, market analysis, and interviews with successful traders. It’s a great resource for those looking to refine their day trading skills.</p>

<h3 class="bold-heading">10. The Art of Trading Podcast</h3>
<p>Hosted by Matthew J. Slabosz, this podcast explores various trading strategies and techniques. It offers practical advice and insights for day traders seeking to improve their performance.</p>

<h3 class="bold-heading">11. The Trading Lifestyle Podcast</h3>
<p>This podcast focuses on the lifestyle aspects of trading, including work-life balance and trading psychology. It’s ideal for traders looking to integrate trading into their daily lives effectively.</p>

<h3 class="bold-heading">12. The Trader’s Podcast</h3>
<p>Hosted by Rob Booker, this podcast covers a wide range of trading topics, from technical analysis to trading psychology. It’s a valuable resource for day traders seeking comprehensive insights.</p>

<h3 class="bold-heading">13. The Trading Justice Podcast</h3>
<p>This podcast, hosted by the Justice brothers, offers market analysis, trading strategies, and interviews with industry experts. It’s a great source of information for day traders looking to stay informed.</p>

<h3 class="bold-heading">14. The Financial Independence Podcast</h3>
<p>While not exclusively focused on trading, this podcast explores financial independence and wealth-building strategies. The insights into financial markets and investment strategies are beneficial for day traders.</p>

<h3 class="bold-heading">15. The Meb Faber Show</h3>
<p>Hosted by Meb Faber, this podcast covers investment strategies, market trends, and interviews with financial experts. It’s a valuable resource for day traders looking to broaden their market knowledge.</p>

<h3 class="bold-heading">16. The Real Vision Podcast</h3>
<p>This podcast offers in-depth interviews with financial experts and market analysis. It’s ideal for day traders seeking to understand the broader economic context of their trades.</p>

<h3 class="bold-heading">17. The Macro Voices Podcast</h3>
<p>Hosted by Erik Townsend, this podcast provides insights into macroeconomic trends and their impact on financial markets. It’s a valuable resource for day traders looking to understand market dynamics.</p>

<h3 class="bold-heading">18. The Trading with Venus Podcast</h3>
<p>Hosted by Raman Gill, this podcast covers trading strategies, market analysis, and trading psychology. It’s a great resource for day traders seeking practical advice and insights.</p>

<h3 class="bold-heading">19. The Better System Trader Podcast</h3>
<p>This podcast focuses on systematic trading strategies and market analysis. It’s ideal for day traders looking to incorporate systematic approaches into their trading.</p>

<h3 class="bold-heading">20. The Trading Story Podcast</h3>
<p>This podcast shares the stories of successful traders and their journeys. It’s a source of inspiration and motivation for day traders looking to learn from the experiences of others.</p>

<h3 class="bold-heading">21. The Mind Over Markets Podcast</h3>
<p>Focusing on trading psychology and mindset, this podcast offers insights into the mental aspects of trading. It’s a valuable resource for day traders looking to enhance their decision-making skills.</p>

<p>These podcasts offer a wealth of knowledge and inspiration for day traders. By tuning in, traders can stay informed about market trends, learn new strategies, and gain insights from experienced professionals. Whether you’re looking to refine your skills or find motivation, these podcasts are a great place to start.</p>

        `,
    styleClass: "style-3",
    image: blog3,
  },
  {
    id: 4,
    title: "Why Day Traders Love ",
    colorText: "Trading Gold",
    content: `
        <p>Gold has long been a favorite among day traders, offering a unique blend of volatility, liquidity, and market dynamics that make it an exciting asset to trade. With gold prices reaching all-time highs, the allure of trading this precious metal has only intensified. Here’s why gold is so appealing to day traders and what you should consider when trading it.</p>
          <h1>The Appeal of Gold for Day Traders</h1>
          
          <h3>1. 24-Hour Trading</h3>
          <p>One of the key advantages of trading gold is its availability around the clock. Unlike some markets that have limited trading hours, gold can be traded 24 hours a day, five days a week. This continuous trading window allows day traders to capitalize on opportunities at any time, whether during the Asian, European, or American trading sessions.</p>
          
          <h3>2. Intraday Volatility</h3>
          <p>Gold is known for its significant intraday volatility, often varying by 100 to 200 pips per day. This volatility creates numerous opportunities for day traders to profit from both upward and downward movements within a single trading session. The potential for larger profits makes gold trading particularly exciting for those who thrive on quick decision-making and rapid execution.</p>
          
          <h3>3. Reaction to Economic News</h3>
          <p>Gold prices are highly sensitive to economic news and geopolitical events, making it an ideal asset for day traders who follow market news closely. Events such as central bank announcements, inflation data releases, and geopolitical tensions can lead to sharp price movements, providing ample trading opportunities.</p>
          
          <h3>4. All-Time Highs</h3>
          <p>With gold prices reaching all-time highs, the market has become even more attractive to traders. The upward trend in gold prices reflects its status as a safe-haven asset, especially during times of economic uncertainty. This trend can offer day traders additional opportunities to capitalize on bullish movements.</p>
    
          <h1>Challenges of Day Trading Gold</h1>
          
          <h3>1. Managing Volatility</h3>
          <p>The same volatility that creates opportunities can also pose risks. Rapid price swings can lead to significant losses if trades are not carefully managed. Day traders must employ robust risk management strategies, such as setting tight stop-loss orders, to protect their capital.</p>
          
          <h3>2. Complexity of Influences</h3>
          <p>Gold prices are affected by a myriad of factors, including interest rates, currency movements, and geopolitical events. This complexity requires day traders to stay informed and be ready to adapt their strategies quickly in response to new information.</p>
          
          <h3>3. Leverage Considerations</h3>
          <p>Day trading gold often involves the use of leverage, which can amplify both gains and losses. While leverage can enhance returns, it also increases the potential for significant losses. Traders must use leverage judiciously and ensure they have adequate risk management measures in place.</p>
    
          <h1>Conclusion</h1>
          <p>Gold’s 24-hour trading availability, intraday volatility, and responsiveness to market news make it a compelling choice for day traders. With prices at all-time highs and the potential for significant daily price movements, gold offers exciting opportunities for those looking to capitalize on short-term market dynamics. However, it’s essential to approach gold trading with a clear understanding of the risks involved. By employing effective risk management strategies and staying informed about market developments, day traders can navigate the challenges of trading gold and capitalize on its unique opportunities.</p>
        `,
    styleClass: "style-3",
    image: blog4,
  },
  {
    id: 5,
    title: "Why Day Traders Love ",
    colorText: "Trading Gold",
    content: "",
    styleClass: "style-3",
    image: blog4,
  },
];

export const blogDataSmall = [
  {
    id: 1,
    title: "How to Choose the Right Trading Style and Strategy",
    image: blog1,
    description: "Embarking on a trading journey can be both exciting and daunting. With a myriad of trading styles and strategies available,…",
    pillName: "trader_qna",
  },
  {
    id: 2,
    title: "How to Spot Trend Reversals in Trading",
    image: blog2,
    description: "Identifying trend reversals in financial markets is a crucial skill for traders and investors. Recognizing when a trend is losing…",
    pillName: "trader_qna",
  },
  {
    id: 3,
    title: "20+ Best Day Trading Podcasts to Get Inspired in 2024",
    image: blog3,
    description: "In the fast-paced world of day trading, staying informed and inspired is crucial for success. Podcasts offer a convenient way…",
    pillName: "trader_qna",
  },
  {
    id: 4,
    title: "Why Day Traders Love Trading Gold",
    image: blog4,
    description: "Gold has long been a favorite among day traders, offering a unique blend of volatility, liquidity, and market dynamics that…",
    pillName: "trader_qna",
  },
  {
    id: 5,
    title: "Weekly Market Outlook: February 10, 2025",
    image: blog5,
    description: "Markets are pushing forward, but risks are lurking. The economy remains resilient, job numbers are strong, and the Fed is trying to keep a cool head…",
    pillName: "weekly_report",
  },
  {
    id: 6,
    title: "Weekly Market Outlook: Feb 17th, 2025",
    image: blog5,
    description: "DAX is up 15% YTD as German elections approach, while European bond yields are surging on expectations of a $3 trillion defense spending package…",
    pillName: "weekly_report",
  },
  {
    id: 7,
    title: "Weekly Market Outlook: Feb 24th, 2025",
    image: figure5,
    description: "Volatility is creeping back in, and traders are gearing up for what could be a pivotal week. After retail sales disappointed and Walmart confirmed a bleak 2025...",
    pillName: "weekly_report",
  },
  {
    id: 8,
    title: "Weekly Market Outlook: March 3, 2025",
    image: blog8,
    description: "As Q1 unfolds, market volatility is picking up, driven by weakening economic data and shifting policy expectations. The latest AtlantaFed GDPNow estimate...",
    pillName: "weekly_report",
  },
  {
    id: 9,
    title: "Weekly Market Outlook – March 10, 2025",
    image: blog9,
    description: "Big moves are happening across global markets, and traders need to stay sharp. The U.S. economy has run into a wall—whether by design or sheer momentum...",
    pillName: "weekly_report",
  },
  {
    id: 10,
    title: "Weekly Market Outlook: March 17, 2025",
    image: blog10,
    description: "A great comment I heard last week: When he said Build the Wall, I didn’t realize it was the Wall of Worry! Markets have been thrown into a blender of stagflation...",
    pillName: "weekly_report",
  },
  {
    id: 11,
    title: "Weekly Market Outlook: March 24, 2025",
    image: blog11,
    description: "The dust has settled from the Great March Option Expiry, leaving the S&P 500 hovering between 5600-5700. The extreme put-buying pressure has faded...",
    pillName: "weekly_report",
  },
  {
    id: 12,
    title: "Weekly Market Outlook: March 31, 2025",
    image: blog13,
    description: "Last week closed on a heavy note—SPX finished at the lows, gold surged into ATH territory, consumer sentiment collapsed, and geopolitical tensions flared...",
    pillName: "weekly_report",
  },
  {
    id: 13,
    title: "Weekly Market Outlook: 7th April, 2025",
    image: blog12,
    description: "It was a brutal week for the Bulls. SPX cracked below support, Bonds surged/Yields cracked, gold exploded to fresh highs, and the market’s soft-landing... ",
    pillName: "weekly_report",
  },
  {
    id: 14,
    title: "Weekly Market Outlook: April 15, 2025",
    image: blog14,
    description: "This week’s trading forecast dives into tariff turmoil, macro crosscurrents, tech tremors, and golden momentum. Markets flirt with a bottom spikes.... ",
    pillName: "weekly_report",
  },
  {
    id: 15,
    title: "Intra-week Market Outlook: April 24, 2025",
    image: blog15,
    description: "The financial markets have experienced significant turbulence since Good Friday, April 18, 2025, driven by geopolitical tensions, trade policy shifts,.... ",
    pillName: "weekly_report",
  },
  {
    id: 16,
    title: "Weekly Market Outlook: April 28, 2025 ",
    image: blog16,
    description: "Trump’s central bank poking, China’s trade flip-flops, and Russia’s staged posturing made for a loud macro week. Yet through it all, the US.... ",
    pillName: "weekly_report",
  },
  {
    id: 17,
    title: "Weekly Market Outlook: May 5, 2025 ",
    image: blog17,
    description: "This week’s trading forecast unpacks sticky macro risks, a fragile technical setup in equities, and what traders should expect from Services PMIs,.... ",
    pillName: "weekly_report",
  },
  {
    id: 18,
    title: "Weekly Market Outlook: May 12, 2025 ",
    image: blog18,
    description: "Markets have been jittery, and for good reason. A continued walk up of indices in the face of increased macro risks has seen many fearing.... ",
    pillName: "weekly_report",
  },
  {
    id: 19,
    title: "Weekly Market Outlook: May 19, 2025 ",
    image: blog19,
    description: "Markets hit a wall as Moody’s strips the U.S. of its final AAA rating, Trump’s tax bill faces internal fire, and semis signal exhaustion. Volatility is creeping back,.... ",
    pillName: "weekly_report",
  },
  {
    id: 20,
    title: "Weekly Market Outlook – May 26, 2025",
    image: blog20,
    description: "Markets limped into Memorial Day weekend with Trump firing trade threats, bonds buckling under supply pressure, and equity breadth,.... ",
    pillName: "weekly_report",
  },
  {
    id: 21,
    title: "Weekly Market Outlook – June 2, 2025",
    image: blog21,
    description: "May’s rally was historic, S&P +6%, Nasdaq +7.2%, but history warns that June could bring turbulence. With global rate volatility rising,.... ",
    pillName: "weekly_report",
  },
  {
    id: 22,
    title: "Weekly Market Outlook – June 9, 2025",
    image: blog22,
    description: "Markets delivered another strong week across major indices. S&P 500, Dow, and Russell 2000 all hit 3.5-month highs, with the Russell.... ",
    pillName: "weekly_report",
  },
  {
    id: 23,
    title: "Weekly Market Outlook – June 16, 2025",
    image: blog23,
    description:
      "Markets retreat as geopolitics flare, Fed and SNB rate moves loom, and equity breadth collapses. Here's your full macro rundown, technical setups, and trading forecast for the week ahead....",
    pillName: "weekly_report",
  },
  {
    id: 24,
    title: "Weekly Market Outlook – June 23, 2025",
    image: blog24,
    description:
      "Markets enter the week walking a tightrope between macro fear and positioning momentum. The Iran strike, looming tariffs, and Q2 earnings risk all swirl into a cocktail of “risk-aware” rallying....",
    pillName: "weekly_report",
  },
  {
    id: 25,
    title: "Weekly Market Outlook – June 30th, 2025",
    image: blog25,
    description:
      "Markets defy gravity as liquidity surges, Fed signals remain mixed, and positioning remains cautious, but breadth continues to deteriorate. Here's your complete macro deep dive, technical setups....",
    pillName: "weekly_report",
  },
  {
    id: 26,
    title: "Weekly Market Outlook – July 7th, 2025",
    image: blog26,
    description: "Markets continue to rise as political theatre, global deflation fears, and dovish central bank signals fuel risk appetite. Behind the headlines, structural forces are shifting....",
    pillName: "weekly_report",
  },
  {
    id: 27,
    title: "Weekly Market Outlook – July 14th, 2025",
    image: blog27,
    description: "Markets grind higher despite tariff shocks, weakening breadth, and rising political risk. All eyes now shift to CPI, earnings, and Trump’s Aug 1 “TACO” deadline....",
    pillName: "weekly_report",
  },
  {
    id: 28,
    title: "Weekly Market Outlook – July 21st, 2025",
    image: blog28,
    description:
      "Markets continue their summer rally despite rising political dysfunction, tariff deadlines, and bubbling risk sentiment. As over 100 S&P companies prepare to report, traders are....",
  },
  {
    id: 29,
    title: "Weekly Market Outlook – July 28th, 2025",
    image: blog29,
    description: "Markets are drifting higher with retail in control, meme stocks in mania mode, and Trump securing back-to-back trade wins. As over 40% of the S&P reports earnings this week....",
  },
  {
    id: 30,
    title: "Weekly Market Outlook – August 4th, 2025",
    image: blog30,
    description:
      "Markets stumbled hard into August as the macro floor gave way beneath a richly priced equity rally. With NFP revisions rattling the Fed and political pressure mounting, the stage....",
  },
  {
    id: 31,
    title: "Weekly Market Outlook – August 11th, 2025",
    image: blog31,
    description:
      "Markets stormed into the second week of August with their strongest performance since June, powered by tech mega-caps, peace chatter between Washington and Moscow, and selective tariff....",
  },
  {
    id: 32,
    title: "Weekly Market Outlook – August 18th, 2025",
    image: blog32,
    description: "Markets enter the week at record highs but on shaky legs, with traders eyeing Jackson Hole for clarity. A 25bp cut in September is now the base case, though whispers of a ....",
  },
  {
    id: 33,
    title: "Weekly Market Outlook – September 8th, 2025",
    image: blog33,
    description: "Markets stumble into September—the seasonally weakest month—caught between softening labour data, Fed cut speculation, and commodity breakouts. Traders are ....",
  },
  {
    id: 34,
    title: "Weekly Market Outlook – September 15th, 2025",
    image: blog34,
    description: "Markets head into one of the heaviest central bank weeks of 2025 with the Fed poised for its first rate cut in nine months, China sliding deeper into deflation ....",
  },
  {
    id: 35,
    title: "Weekly Market Outlook – September 22nd, 2025",
    image: blog35,
    description: "Markets head into the 39th week of 2025, historically the weakest week of the year, with a rare mix of dovish Fed expectations, growing recession fears, and relentless....",
  },
  {
    id: 36,
    title: "Weekly Market Outlook – September 29th, 2025",
    image: blog36,
    description: "Markets closed September steady on the surface but fragile underneath. The Fed’s latest dot plot pushed expectations higher-for-longer, equities remain....",
  },
  {
    id: 37,
    title: "Weekly Market Outlook – October 6th, 2025",
    image: blog37,
    description: "Markets continue to climb the wall of worry, ignoring macro caution as liquidity, leverage, and AI optimism propel equities into parabolic mode. Despite talk of....",
  },
];

export const blogDataHome = [
  {
    id: 1,
    title: "How to Choose the Right Trading Style and Strategy",
    image: blog1,
    description: "Embarking on a trading journey can be both exciting and daunting. With a myriad of trading styles and strategies available,…",
  },
  {
    id: 3,
    title: "20+ Best Day Trading Podcasts to Get Inspired in 2024",
    image: blog3,
    description: "In the fast-paced world of day trading, staying informed and inspired is crucial for success. Podcasts offer a convenient way…",
  },
  {
    id: 4,
    title: "Why Day Traders Love Trading Gold",
    image: blog4,
    description: "Gold has long been a favorite among day traders, offering a unique blend of volatility, liquidity, and market dynamics that…",
  },
  {
    id: 5,
    title: "Weekly Market Outlook",
    image: blog5,
    description: "Markets are pushing forward, but risks are lurking. The economy remains resilient, job numbers are strong, and the Fed is trying to keep a cool head…",
  },
];
